// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../svg/arrowDown.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-light: #f4f9ff;
  --color-white: #ffffff;
  --color-white-2: #fbfcfe;
  --color-primary: #1f68d6;
  --color-primary-2: #3b7ee3;
  --color-primary-3: #ccedff;
  --color-primary-4: #003c97;
  --color-primary-5: #0042a6;
  --color-primary-7: #c1daff;
  --color-primary-8: #97c1ff;
  --color-primary-09: #ccedff;
  --color-mima-light: #eef2f5;
  --color-error: #e12f2f;
  --color-success: #66b032;
  --color-green: #569755;
  --color-green-2: #92e391;
  --color-green-3: #d3eace;
  --color-yellow: #e7d788;
  --color-yellow-2: #ffaa00;
  --color-yellow-3: #8f4f00;
  --color-light-red: #f7d1cd;
  --color-deep-red: #9f0000;
  --color-grey: #b3b3c5;
  --color-grey-2: #d1d1d1;
  --color-grey-3: #e0e9f3;
  --color-grey-4: #d1d1d1;
  --color-grey-5: #ebebf5;
  --color-grey-6: #9898ab;
  --color-table-grey: #fafafc;
  --color-table-grey-1: #f4f4fc;
  --color-dark: #4a4a68;
  --color-dark-2: #1a1a42;
  --color-dark-3: #696365;
  --color-dark-6: #2a2828;
  --color-disabled: #c0c0c0;
  --color-light-blue: #ebf2ff;
  --color-light-blue-2: #d4e5ff;
  --color-light-blue-3: #e7f3fe;
  --color-dark-yellow: #7e6e1f;
  --color-light-brown: #f4f5f6;
  --color-light-green: #e4ffec;
  --color-light-yellow: #fff5d7;
  --color-light-red: #ffe8e8;
  --color-light-grey: #f3f3ff;
  --color-admin: #112855;
  --color-admin-2: #071530;
  --color-admin-3: #020710;
  --default-font-size: 1.8rem;
  --default-font-h1: 6.4rem;
  --default-font-h2: 4rem;
  --default-font-h3: 3.2rem;
  --default-font-subtitle: 2.4rem;
  --default-font-small: 1.4rem;
  --default-font-xsmall: 1.2rem;
}

.Forms_form__Dn8XC {
  display: block;
}
.Forms_form__group__yS6Q4 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.Forms_form__group__yS6Q4:not(:last-child) {
  margin-bottom: 1rem;
}
.Forms_form__pin__input__PMFIZ {
  font-size: 1.8rem;
  font-family: inherit;
  color: #b3b3c5;
  width: 6rem;
  height: 6rem;
  border-radius: 1rem;
  background-color: #ffffff;
  border: 1px solid #4a4a68;
  display: block;
  text-align: center;
}
.Forms_form__pin__input__PMFIZ:focus, .Forms_form__pin__input__PMFIZ:focus-visible, .Forms_form__pin__input__PMFIZ:focus-within {
  color: #4a4a68;
  border: 1px solid #1f68d6;
}
.Forms_form__input__RKgLX {
  font-size: 1.8rem;
  font-family: inherit;
  color: #b3b3c5;
  padding-left: 2rem;
  width: 38rem;
  height: 6rem;
  border-radius: 1rem;
  background-color: #ffffff;
  border: 1px solid #4a4a68;
  display: block;
  box-sizing: border-box;
}
.Forms_form__input__RKgLX:focus, .Forms_form__input__RKgLX:focus-visible, .Forms_form__input__RKgLX:focus-within {
  color: #4a4a68;
  border: 1px solid #1f68d6;
}
.Forms_form__label__2awBb {
  font-size: 1.4rem;
  font-family: inherit;
  padding-left: 2rem;
}
.Forms_form__upload__SF1l2 {
  font-size: 1.8rem;
  font-family: inherit;
  font-weight: 700;
  text-align: center;
  color: #4a4a68;
  width: 38rem;
  height: 6rem;
  border-radius: 1rem;
  background-color: #ccedff;
  border: 1px dashed #4a4a68;
  display: block;
  box-sizing: border-box;
  cursor: pointer;
}
.Forms_form__upload__SF1l2:focus, .Forms_form__upload__SF1l2:focus-visible, .Forms_form__upload__SF1l2:focus-within {
  color: #4a4a68;
  border: 1px solid #1f68d6;
}

.Forms_filled__12-ub {
  color: #4a4a68;
}

.Forms_otp__group__fIay8 {
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
}

button {
  font-family: "Montserrat", sans-serif;
  font-size: 1.8rem;
  display: flex;
  background-color: transparent;
  border: none;
}

.Forms_btn__GNyea {
  padding: 1.9rem 2.2rem;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  font-weight: 700;
  border-radius: 1rem;
  cursor: pointer;
}
.Forms_btn__outline__m2zf4 {
  border: 1px solid #4a4a68;
  margin-right: 2.3rem;
  color: #4a4a68;
}
.Forms_btn__outline__m2zf4:hover {
  border: 1px solid #1f68d6;
  color: #1f68d6;
}
.Forms_btn__default__WPhM6 {
  background-color: #3b7ee3;
  color: #ffffff;
}
.Forms_btn__default__WPhM6:hover {
  background-color: #003c97;
}
.Forms_btn__default_38__ifmOS {
  background-color: #3b7ee3;
  color: #ffffff;
  width: 38rem;
}
.Forms_btn__default_38__ifmOS:hover {
  background-color: #003c97;
}
.Forms_btn__icon__VZSyI {
  height: 2.2rem;
  margin-right: 1rem;
}
.Forms_btn__form__mXTG\\+ {
  background-color: #3b7ee3;
  color: #ffffff;
  width: 100%;
  margin-top: 2rem;
}
.Forms_btn__form__mXTG\\+:hover {
  background-color: #003c97;
}
.Forms_btn__text__e2Iul {
  color: #3b7ee3;
  text-decoration: underline;
  position: relative;
  left: 29rem;
}
.Forms_btn__text__e2Iul:hover {
  color: #003c97;
}
.Forms_btn__text__e2Iul::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  height: 100%;
  width: 1.6rem;
  right: 0;
  top: 2.5rem;
}

.Forms_select__pAh0r {
  display: flex;
  width: 38rem;
  flex-direction: column;
  margin-top: 3rem;
}
.Forms_select__options__VrIE7 {
  padding: 1.5rem 2rem;
  cursor: pointer;
  width: 100%;
}
.Forms_select__options__VrIE7:hover {
  background-color: #1f68d6;
  color: #ffffff;
}
.Forms_select__options_selected__b6PHs {
  font-size: 1.8rem;
  font-family: inherit;
  color: #4a4a68;
  padding-left: 2rem;
  width: 38rem;
  height: 6rem;
  border-radius: 1rem;
  background-color: #ffffff;
  border: 1px solid #4a4a68;
  display: block;
  cursor: pointer;
  margin-bottom: 1rem;
  position: relative;
  order: 0;
  box-sizing: border-box;
}
.Forms_select__options_selected__b6PHs > * {
  position: relative;
  top: 1.8rem;
}
.Forms_select__options_selected__b6PHs::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  height: 100%;
  width: 1.6rem;
  right: 2rem;
  top: 2.5rem;
  transition: all 0.4s;
}
.Forms_select__options_active__VN9a7 + .Forms_select__options_selected__b6PHs::after {
  transform: rotateX(180deg);
  top: -2.5rem;
}
.Forms_select__options_container__VgPQL {
  color: #4a4a68;
  width: 100%;
  max-height: 27rem;
  border-radius: 1rem;
  background-color: #ffffff;
  border: 1px solid #4a4a68;
  order: 1;
  overflow-y: scroll;
  margin-bottom: 2rem;
  transition: all 0.4s;
  box-sizing: border-box;
}
.Forms_select__options_container__VgPQL::-webkit-scrollbar {
  width: 1rem;
  background-color: #ffffff;
  border-radius: 0 1rem 1rem 0;
}
.Forms_select__options_container__VgPQL::-webkit-scrollbar-thumb {
  background-color: #b3b3c5;
  border-radius: 1rem;
}
.Forms_select__options_active__VN9a7 {
  opacity: 1;
  max-height: 27rem;
  overflow-y: scroll;
}
.Forms_select__options_label__NjTm8 {
  cursor: pointer;
}

.Forms_error__jZW2R {
  font-size: var(--default-font-small);
  color: var(--color-error);
  padding-left: 2rem;
  font-weight: 400;
  margin: 1rem 0;
}

.Forms_uploadLogo__\\+PPx\\+ {
  height: 10rem;
  border-radius: 2rem;
  border: 3px solid var(--color-primary);
  margin: 2rem 0;
  padding: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables/_variables.scss","webpack://./src/assets/styles/Onboarding/Forms.module.scss"],"names":[],"mappings":"AAAA;EAEC,sBAAA;EACA,sBAAA;EACA,wBAAA;EAEA,wBAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EAEA,sBAAA;EACA,wBAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EAEA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EAEA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,6BAAA;EAEA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EAEA,sBAAA;EACA,wBAAA;EACA,wBAAA;EAGA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,yBAAA;EACA,+BAAA;EACA,4BAAA;EACA,6BAAA;ACTD;;AAnDA;EACC,cAAA;AAsDD;AApDC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AAsDF;AArDE;EACC,mBAAA;AAuDH;AAnDC;EACC,iBDgFkB;EC/ElB,oBAAA;EACA,cDmEW;EClEX,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBD8CY;EC7CZ,yBAAA;EACA,cAAA;EACA,kBAAA;AAqDF;AAnDE;EAGC,cD6DU;EC5DV,yBAAA;AAmDH;AA/CC;EACC,iBD4DkB;EC3DlB,oBAAA;EACA,cD+CW;EC9CX,kBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBDyBY;ECxBZ,yBAAA;EACA,cAAA;EACA,sBAAA;AAiDF;AA/CE;EAGC,cDwCU;ECvCV,yBAAA;AA+CH;AA3CC;EACC,iBD4CmB;EC3CnB,oBAAA;EACA,kBAAA;AA6CF;AA1CC;EACC,iBDiCkB;EChClB,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cDwBW;ECtBX,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBDCgB;ECAhB,0BAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;AA2CF;AAzCE;EAGC,cDUU;ECTV,yBAAA;AAyCH;;AAlCA;EACC,cDCY;ACoCb;;AAjCA;EACC,aAAA;EACA,SAAA;EACA,gBAAA;AAoCD;;AAhCA;EACC,qCAAA;EACA,iBDPmB;ECQnB,aAAA;EACA,6BAAA;EACA,YAAA;AAmCD;;AAhCA;EACC,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAmCD;AAjCC;EACC,yBAAA;EACA,oBAAA;EACA,cD9BW;ACiEb;AAjCE;EACC,yBAAA;EACA,cDtDa;ACyFhB;AA/BC;EACC,yBD1DgB;EC2DhB,cD/DY;ACgGd;AA/BE;EACC,yBD5De;AC6FlB;AA7BC;EACC,yBDnEgB;ECoEhB,cDxEY;ECyEZ,YAAA;AA+BF;AA7BE;EACC,yBDtEe;ACqGlB;AA3BC;EACC,cAAA;EACA,kBAAA;AA6BF;AA1BC;EACC,yBDlFgB;ECmFhB,cDvFY;ECwFZ,WAAA;EACA,gBAAA;AA4BF;AA1BE;EACC,yBDtFe;ACkHlB;AAxBC;EACC,cD7FgB;EC8FhB,0BAAA;EACA,kBAAA;EACA,WAAA;AA0BF;AAxBE;EACC,cDjGe;AC2HlB;AAvBE;EACC,WAAA;EACA,mDAAA;EACA,wBAAA;EACA,4BAAA;EAEA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;AAwBH;;AAlBA;EACC,aAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AAqBD;AAnBC;EACC,oBAAA;EACA,eAAA;EACA,WAAA;AAqBF;AAnBE;EACC,yBDnIa;ECoIb,cDvIW;AC4Jd;AAlBE;EACC,iBD/GiB;ECgHjB,oBAAA;EACA,cDtHU;ECuHV,kBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBDlJW;ECmJX,yBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,sBAAA;AAoBH;AAlBG;EACC,kBAAA;EACA,WAAA;AAoBJ;AAhBE;EACC,WAAA;EACA,mDAAA;EACA,wBAAA;EACA,4BAAA;EAEA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EAEA,oBAAA;AAgBH;AAbE;EACC,0BAAA;EACA,YAAA;AAeH;AAZE;EACC,cD/JU;ECgKV,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBD1LW;EC2LX,yBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;AAcH;AAZG;EACC,WAAA;EACA,yBDpMU;ECqMV,4BAAA;AAcJ;AAXG;EACC,yBDxLS;ECyLT,mBAAA;AAaJ;AATE;EACC,UAAA;EACA,iBAAA;EACA,kBAAA;AAWH;AARE;EACC,eAAA;AAUH;;AALA;EACC,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAQD;;AALA;EACC,aAAA;EACA,mBAAA;EACA,sCAAA;EACA,cAAA;EACA,eAAA;AAQD","sourcesContent":[":root {\n\t//COLORS\n\t--color-light: #f4f9ff;\n\t--color-white: #ffffff;\n\t--color-white-2: #fbfcfe;\n\n\t--color-primary: #1f68d6;\n\t--color-primary-2: #3b7ee3;\n\t--color-primary-3: #ccedff;\n\t--color-primary-4: #003c97;\n\t--color-primary-5: #0042a6;\n\t--color-primary-7: #c1daff;\n\t--color-primary-8: #97c1ff;\n\t--color-primary-09: #ccedff;\n\t--color-mima-light: #eef2f5;\n\n\t--color-error: #e12f2f;\n\t--color-success: #66b032;\n\t--color-green: #569755;\n\t--color-green-2: #92e391;\n\t--color-green-3: #d3eace;\n\t--color-yellow: #e7d788;\n\t--color-yellow-2: #ffaa00;\n\t--color-yellow-3: #8f4f00;\n\t--color-light-red: #f7d1cd;\n\t--color-deep-red: #9f0000;\n\n\t--color-grey: #b3b3c5;\n\t--color-grey-2: #d1d1d1;\n\t--color-grey-3: #e0e9f3;\n\t--color-grey-4: #d1d1d1;\n\t--color-grey-5: #ebebf5;\n\t--color-grey-6: #9898ab;\n\t--color-table-grey: #fafafc;\n\t--color-table-grey-1: #f4f4fc;\n\n\t--color-dark: #4a4a68;\n\t--color-dark-2: #1a1a42;\n\t--color-dark-3: #696365;\n\t--color-dark-6: #2a2828;\n\n\t--color-disabled: #c0c0c0;\n\t--color-light-blue: #ebf2ff;\n\t--color-light-blue-2: #d4e5ff;\n\t--color-light-blue-3: #e7f3fe;\n\n\t--color-dark-yellow: #7e6e1f;\n\t--color-light-brown: #f4f5f6;\n\t--color-light-green: #e4ffec;\n\t--color-light-yellow: #fff5d7;\n\t--color-light-red: #ffe8e8;\n\t--color-light-grey: #f3f3ff;\n\n\t--color-admin: #112855;\n\t--color-admin-2: #071530;\n\t--color-admin-3: #020710;\n\n\t// FONT\n\t--default-font-size: 1.8rem;\n\t--default-font-h1: 6.4rem;\n\t--default-font-h2: 4rem;\n\t--default-font-h3: 3.2rem;\n\t--default-font-subtitle: 2.4rem;\n\t--default-font-small: 1.4rem;\n\t--default-font-xsmall: 1.2rem;\n}\n\n//COLORS\n$color-light: #f4f9ff;\n$color-white: #ffffff;\n$color-white-2: #fbfcfe;\n\n$color-primary: #1f68d6;\n$color-primary-2: #3b7ee3;\n$color-primary-3: #ccedff;\n$color-primary-4: #003c97;\n$color-primary-7: #c1daff;\n$color-primary-09: #ccedff;\n\n$color-error: #e12f2f;\n$color-success: #66b032;\n$color-green: #569755;\n$color-green-2: #92e391;\n$color-yellow: #e7d788;\n$color-light-red: #f7d1cd;\n\n$color-grey: #b3b3c5;\n$color-grey-2: #d1d1d1;\n$color-grey-3: #e0e9f3;\n$color-grey-4: #d1d1d1;\n$color-grey-6: #9898ab;\n\n$color-dark: #4a4a68;\n$color-dark-3: #696365;\n$color-dark-6: #2a2828;\n\n// FONT\n$default-font-size: 1.8rem;\n$default-font-h1: 6.4rem;\n$default-font-h2: 4rem;\n$default-font-h3: 3.2rem;\n$default-font-subtitle: 2.4rem;\n$default-font-small: 1.4rem;\n\n// SHADOWS\n$shadow-dark: 0 2rem 6rem rgba(0, 0, 0, 0.3);\n$shadow-light: 0 2rem 5rem rgba(0, 0, 0, 0.06);\n","@import '../variables/variables';\n\n//FORM side\n\n.form {\n\tdisplay: block;\n\n\t&__group {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\t&:not(:last-child) {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\t}\n\n\t&__pin__input {\n\t\tfont-size: $default-font-size;\n\t\tfont-family: inherit;\n\t\tcolor: $color-grey;\n\t\twidth: 6rem;\n\t\theight: 6rem;\n\t\tborder-radius: 1rem;\n\t\tbackground-color: $color-white;\n\t\tborder: 1px solid $color-dark;\n\t\tdisplay: block;\n\t\ttext-align: center;\n\n\t\t&:focus,\n\t\t&:focus-visible,\n\t\t&:focus-within {\n\t\t\tcolor: $color-dark;\n\t\t\tborder: 1px solid $color-primary;\n\t\t}\n\t}\n\n\t&__input {\n\t\tfont-size: $default-font-size;\n\t\tfont-family: inherit;\n\t\tcolor: $color-grey;\n\t\tpadding-left: 2rem;\n\t\twidth: 38rem;\n\t\theight: 6rem;\n\t\tborder-radius: 1rem;\n\t\tbackground-color: $color-white;\n\t\tborder: 1px solid $color-dark;\n\t\tdisplay: block;\n\t\tbox-sizing: border-box;\n\n\t\t&:focus,\n\t\t&:focus-visible,\n\t\t&:focus-within {\n\t\t\tcolor: $color-dark;\n\t\t\tborder: 1px solid $color-primary;\n\t\t}\n\t}\n\n\t&__label {\n\t\tfont-size: $default-font-small;\n\t\tfont-family: inherit;\n\t\tpadding-left: 2rem;\n\t}\n\n\t&__upload {\n\t\tfont-size: $default-font-size;\n\t\tfont-family: inherit;\n\t\tfont-weight: 700;\n\t\ttext-align: center;\n\t\tcolor: $color-dark;\n\n\t\twidth: 38rem;\n\t\theight: 6rem;\n\t\tborder-radius: 1rem;\n\t\tbackground-color: $color-primary-3;\n\t\tborder: 1px dashed $color-dark;\n\t\tdisplay: block;\n\t\tbox-sizing: border-box;\n\t\tcursor: pointer;\n\n\t\t&:focus,\n\t\t&:focus-visible,\n\t\t&:focus-within {\n\t\t\tcolor: $color-dark;\n\t\t\tborder: 1px solid $color-primary;\n\t\t}\n\t}\n}\n\n// When form is filled\n\n.filled {\n\tcolor: $color-dark;\n}\n\n//otp styles\n.otp__group {\n\tdisplay: flex;\n\tgap: 2rem;\n\tmargin-top: 1rem;\n}\n\n// button style\nbutton {\n\tfont-family: 'Montserrat', sans-serif;\n\tfont-size: $default-font-size;\n\tdisplay: flex;\n\tbackground-color: transparent;\n\tborder: none;\n}\n\n.btn {\n\tpadding: 1.9rem 2.2rem;\n\tjustify-content: center;\n\talign-items: center;\n\ttext-decoration: none;\n\tfont-weight: 700;\n\tborder-radius: 1rem;\n\tcursor: pointer;\n\n\t&__outline {\n\t\tborder: 1px solid $color-dark;\n\t\tmargin-right: 2.3rem;\n\t\tcolor: $color-dark;\n\n\t\t&:hover {\n\t\t\tborder: 1px solid $color-primary;\n\t\t\tcolor: $color-primary;\n\t\t}\n\t}\n\n\t&__default {\n\t\tbackground-color: $color-primary-2;\n\t\tcolor: $color-white;\n\n\t\t&:hover {\n\t\t\tbackground-color: $color-primary-4;\n\t\t}\n\t}\n\n\t&__default_38 {\n\t\tbackground-color: $color-primary-2;\n\t\tcolor: $color-white;\n\t\twidth: 38rem;\n\n\t\t&:hover {\n\t\t\tbackground-color: $color-primary-4;\n\t\t}\n\t}\n\n\t&__icon {\n\t\theight: 2.2rem;\n\t\tmargin-right: 1rem;\n\t}\n\n\t&__form {\n\t\tbackground-color: $color-primary-2;\n\t\tcolor: $color-white;\n\t\twidth: 100%;\n\t\tmargin-top: 2rem;\n\n\t\t&:hover {\n\t\t\tbackground-color: $color-primary-4;\n\t\t}\n\t}\n\n\t&__text {\n\t\tcolor: $color-primary-2;\n\t\ttext-decoration: underline;\n\t\tposition: relative;\n\t\tleft: 29rem;\n\n\t\t&:hover {\n\t\t\tcolor: $color-primary-4;\n\t\t}\n\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tbackground: url('../../svg/arrowDown.svg');\n\t\t\tbackground-size: contain;\n\t\t\tbackground-repeat: no-repeat;\n\n\t\t\tposition: absolute;\n\t\t\theight: 100%;\n\t\t\twidth: 1.6rem;\n\t\t\tright: 0;\n\t\t\ttop: 2.5rem;\n\t\t}\n\t}\n}\n\n//Dropdown or Select\n.select {\n\tdisplay: flex;\n\twidth: 38rem;\n\tflex-direction: column;\n\tmargin-top: 3rem;\n\n\t&__options {\n\t\tpadding: 1.5rem 2rem;\n\t\tcursor: pointer;\n\t\twidth: 100%;\n\n\t\t&:hover {\n\t\t\tbackground-color: $color-primary;\n\t\t\tcolor: $color-white;\n\t\t}\n\n\t\t&_selected {\n\t\t\tfont-size: $default-font-size;\n\t\t\tfont-family: inherit;\n\t\t\tcolor: $color-dark;\n\t\t\tpadding-left: 2rem;\n\t\t\twidth: 38rem;\n\t\t\theight: 6rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: $color-white;\n\t\t\tborder: 1px solid $color-dark;\n\t\t\tdisplay: block;\n\t\t\tcursor: pointer;\n\t\t\tmargin-bottom: 1rem;\n\t\t\tposition: relative;\n\t\t\torder: 0;\n\t\t\tbox-sizing: border-box;\n\n\t\t\t& > * {\n\t\t\t\tposition: relative;\n\t\t\t\ttop: 1.8rem;\n\t\t\t}\n\t\t}\n\n\t\t&_selected::after {\n\t\t\tcontent: '';\n\t\t\tbackground: url('../../svg/arrowDown.svg');\n\t\t\tbackground-size: contain;\n\t\t\tbackground-repeat: no-repeat;\n\n\t\t\tposition: absolute;\n\t\t\theight: 100%;\n\t\t\twidth: 1.6rem;\n\t\t\tright: 2rem;\n\t\t\ttop: 2.5rem;\n\n\t\t\ttransition: all 0.4s;\n\t\t}\n\n\t\t&_active + &_selected::after {\n\t\t\ttransform: rotateX(180deg);\n\t\t\ttop: -2.5rem;\n\t\t}\n\n\t\t&_container {\n\t\t\tcolor: $color-dark;\n\t\t\twidth: 100%;\n\t\t\tmax-height: 27rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: $color-white;\n\t\t\tborder: 1px solid $color-dark;\n\t\t\torder: 1;\n\t\t\toverflow-y: scroll;\n\t\t\tmargin-bottom: 2rem;\n\t\t\ttransition: all 0.4s;\n\t\t\tbox-sizing: border-box;\n\n\t\t\t&::-webkit-scrollbar {\n\t\t\t\twidth: 1rem;\n\t\t\t\tbackground-color: $color-white;\n\t\t\t\tborder-radius: 0 1rem 1rem 0;\n\t\t\t}\n\n\t\t\t&::-webkit-scrollbar-thumb {\n\t\t\t\tbackground-color: $color-grey;\n\t\t\t\tborder-radius: 1rem;\n\t\t\t}\n\t\t}\n\n\t\t&_active {\n\t\t\topacity: 1;\n\t\t\tmax-height: 27rem;\n\t\t\toverflow-y: scroll;\n\t\t}\n\n\t\t&_label {\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n}\n\n.error {\n\tfont-size: var(--default-font-small);\n\tcolor: var(--color-error);\n\tpadding-left: 2rem;\n\tfont-weight: 400;\n\tmargin: 1rem 0;\n}\n\n.uploadLogo {\n\theight: 10rem;\n\tborder-radius: 2rem;\n\tborder: 3px solid var(--color-primary);\n\tmargin: 2rem 0;\n\tpadding: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `Forms_form__Dn8XC`,
	"form__group": `Forms_form__group__yS6Q4`,
	"form__pin__input": `Forms_form__pin__input__PMFIZ`,
	"form__input": `Forms_form__input__RKgLX`,
	"form__label": `Forms_form__label__2awBb`,
	"form__upload": `Forms_form__upload__SF1l2`,
	"filled": `Forms_filled__12-ub`,
	"otp__group": `Forms_otp__group__fIay8`,
	"btn": `Forms_btn__GNyea`,
	"btn__outline": `Forms_btn__outline__m2zf4`,
	"btn__default": `Forms_btn__default__WPhM6`,
	"btn__default_38": `Forms_btn__default_38__ifmOS`,
	"btn__icon": `Forms_btn__icon__VZSyI`,
	"btn__form": `Forms_btn__form__mXTG+`,
	"btn__text": `Forms_btn__text__e2Iul`,
	"select": `Forms_select__pAh0r`,
	"select__options": `Forms_select__options__VrIE7`,
	"select__options_selected": `Forms_select__options_selected__b6PHs`,
	"select__options_active": `Forms_select__options_active__VN9a7`,
	"select__options_container": `Forms_select__options_container__VgPQL`,
	"select__options_label": `Forms_select__options_label__NjTm8`,
	"error": `Forms_error__jZW2R`,
	"uploadLogo": `Forms_uploadLogo__+PPx+`
};
export default ___CSS_LOADER_EXPORT___;
